"use strict";module.exports = function () {
  // eslint-disable-next-line max-len,quotes
  return '<symbol viewbox="0 0 8 14" id=icon-carousel-prev><path d="M7.004 14a.999.999 0 01-.71-.291L.29 7.683a1.007 1.007 0 010-1.416L6.293.241a.998.998 0 011.359.053c.37.371.392.965.052 1.364L2.412 6.97l5.292 5.313c.287.286.375.717.221 1.093a1 1 0 01-.921.624z"></path></symbol>';
};